import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../../utils/API/responseMiddleware";
import { transformRequest } from "../../../../utils/API/requestMiddleware";

const EventQuestionAnswerApi = createApi({
    reducerPath: 'EventQuestionAnswerApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getFormQuestionAnswerEventDetailList: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/GetFormQuestionAnswerEventDetailList',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllFormQuestionAnswerListByEventId: builder.query({
            query: (details) => ({
                url: `/EventManagement/GetAllFormQuestionAnswerListByEventId?id=${details.eventId}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})
export const {
    useGetFormQuestionAnswerEventDetailListMutation,
    useLazyGetAllFormQuestionAnswerListByEventIdQuery
} = EventQuestionAnswerApi;

export default EventQuestionAnswerApi;
